import Plyr from 'plyr';

export default {
    init() {
        const podcastHero = document.querySelectorAll('[data-podcast-hero]');

        podcastHero.forEach(podcast => {
            const player = new Plyr(podcast.querySelector('[data-plyr]'), {
                autoplay: true,
                invertTime: false
            });
        });
    }
};
